const LogoHeader = () => (
  <>
    <nav className="flex justify-center md:justify-start py-4 px-8 gap-12 bg-primary text-white fixed top-0 left-0 right-0 z-50">
      <img alt="logo" className="h-14" src="/logo.png" />
    </nav>
  </>
)

export default LogoHeader
